<template>
  <div class="card mb-5 mb-xxl-8">
    <!--begin::Body-->
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label"> {{ $t('shop.product_list') }} </h3>
        </div>
        <div class="card-toolbar" v-if="!shop.archive && !$hasShopModule('pos.stock')">
          <select
                  name="quick_add_action"
                  v-model="quickAddAction"
                  class="form-select form-select-solid kt_select2"
                  data-control="select2"
                  data-search="true"
                  data-allow-clear="true"
                  :data-placeholder="$t('store.entrie.make_entry')"
                  style="width: 150px;">
            <option value="add_item">{{ $t('store.entrie.add') }}</option>
            <option value="add_by_category">{{ $t('store.entrie.add_by_cat') }}</option>
          </select>
        </div>
      </div>

      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Table-->
          <table class="table align-middle table-row-bordered fs-6 gy-3 shop-products-table" id="kt_datatable_shop_products">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-100px">{{ $t('product.name')}}</th>
              <th class="min-w-100px">{{ $t('shop.price')}}</th>
              <th class="min-w-100px">{{ $t('shop.price_ttc')}}</th>
              <template v-if="$hasShopModule('pos.stock')">
                <th class="min-w-100px">{{ $t('product.stock')}}</th>
              </template>
              <th class="min-w-100px">{{ $t('product.status')}}</th>
              <template v-if="$hasShopModule('pos.stock')">
                <th class="min-w-100px">{{ $t('product.stock_security')}}</th>
                <th class="min-w-100px">{{ $t('product.stock_alert')}}</th>
              </template>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
          <!--end::Table-->
        </div>
        <!--end::Layout-->
      </div>

      <update-shop-product
      :form="formProductEditData"
      :get-taxes="getTaxes"
      @success="loadShopProduct"
      ></update-shop-product>

      <div class="modal bg-white fade" tabindex="-1" id="quickAddShopProductModal">
        <div class="modal-dialog modal-fullscreen">
          <form @submit.prevent="submitQuickAdd" class="modal-content shadow-none">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('shop.product_list') }}</h5>
              <div class="row">
                <div class="col-sm-4">
                  <div class="d-flex align-items-center flex-equal fw-row me-4 order-2">
                    <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('store.output.create.date') }}</div>
                    <div class="position-relative d-flex align-items-center w-200px">
                      <input class="form-control form-control-solid fw-bolder pe-5" :value="formatDateToday()" disabled />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <bouton :title="currency.currency_symbol ? currency.currency_name : ''" class="btn btn-light-primary">
                    {{ $t('delivery.currency') }} ({{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})
                  </bouton>
                </div>
                <div class="col-sm-4">
                  <div class="d-flex flex-center fw-row order-1 order-2">
                    <span class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('shop.entries') }} : </span>
                    <input type="text" class="form-control form-control-transparent fw-bolder fs-3 w-250px" disabled />
                  </div>
                </div>
              </div>
              <div class="quick-add-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x">x</span>
              </div>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row bg-light rounded py-6 my-2" v-for="(item, index) in quickAddProducts" :key="index">
                    <div class="col">
                      <div class="row">
                        <div class="col-md-6 my-2">
                          <label class="required form-label">{{ $t('store.product_placeholder') }}</label>
                          <select
                              :id="'quick_add_product' + index"
                              required
                              :data-product-key="index"
                              class="form-select kt_select2 h-50px"
                              data-control="select2"
                              name="product"
                              data-dropdown-parent="#quickAddShopProductModal"
                              :data-placeholder="$t('store.product_placeholder')"
                              data-allow-clear="false"
                          >
                            <option></option>
                            <option v-for="product in filterQuickAddProducts(index)" :key="product.id" :value="product.id">
                              {{ product.declination_title }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-3 my-2">
                          <label class="required form-label">{{ $t('product.sell_price_ht') }}</label>
                          <input required type="number" min="0" v-model="item.sellPrice" class="form-control h-50px" />
                        </div>
                        <div class="col-md-3 my-2">
                          <label class="form-label">{{ $t('product.taxes') }}</label>
                          <select :id="'quick_add_taxe' + index" :data-product-key="index"
                                  class="form-select kt_select2 h-50px" data-control="select2" name="taxes[]"
                                  multiple="multiple"
                                  data-dropdown-parent="#quickAddShopProductModal"
                                  :data-placeholder="$t('product.taxes')" data-search="true">
                            <option v-for="taxe in getTaxes" :key="taxe.id" :value="taxe.id">{{ taxe.title }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-1" v-if="quickAddProducts.length > 1">
                      <button @click.prevent="removeQuickAddRow(index)" type="button"
                              class="btn btn-sm btn-icon text-danger btn-active-color-danger">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-8"></div>
                    <div class="col-sm-4 text-end">
                      <button @click.prevent="addQuickAddRow" type="button" class="btn btn-light-primary btn-sm my-3">
                        <i class="fa fa-plus"></i>
                        {{ $t('product.add_product') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isQuickAddLoading">
                {{ $t('button.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="modal bg-white fade" tabindex="-1" id="quickAddByCategoryModal">
        <div class="modal-dialog modal-fullscreen">
          <form @submit.prevent="submitQuickAddByCategory" class="modal-content shadow-none">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('shop.product_list') }}</h5>
              <div class="row">
                <div class="col-sm-4">
                  <div class="d-flex align-items-center flex-equal fw-row me-4 order-2">
                    <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('store.output.create.date') }}</div>
                    <div class="position-relative d-flex align-items-center w-200px">
                      <input class="form-control form-control-solid fw-bolder pe-5" :value="formatDateToday()" disabled />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <bouton :title="currency.currency_symbol ? currency.currency_name : ''" class="btn btn-light-primary">
                    {{ $t('delivery.currency') }} ({{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})
                  </bouton>
                </div>
                <div class="col-sm-4">
                  <div class="d-flex flex-center fw-row order-1 order-2">
                    <span class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('shop.entries') }} : </span>
                    <input type="text" class="form-control form-control-transparent fw-bolder fs-3 w-250px" disabled />
                  </div>
                </div>
              </div>
              <div class="quick-add-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x">x</span>
              </div>
            </div>
            <div class="modal-body">
              <div class="row bg-light rounded p-5 mb-5">
                <div class="col-md-12">
                  <label class="required form-label">{{ $t('product.category') }}</label>
                  <select
                      id="quick_add_category_select"
                      class="form-select kt_select2 h-50px"
                      data-control="select2"
                      data-dropdown-parent="#quickAddByCategoryModal"
                      multiple
                  >
                    <template v-for="category in getCategories" :key="category.id">
                      <option disabled class="parent-option">{{ category.name }}</option>
                      <option v-for="sub in category.childrens" :key="sub.id" :value="sub.id">
                        &nbsp;&nbsp;— {{ sub.name }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>

              <div class="card" v-if="categoryQuickAddProducts.length > 0">
                <div class="card-body">
                  <div class="alert alert-info fw-bold">
                    {{ $t('store.entrie.products_found') }} : {{ categoryQuickAddProducts.length }}
                  </div>
                  <div class="row bg-light rounded py-6 my-2" v-for="(item, index) in categoryQuickAddProducts" :key="index">
                    <div class="col">
                      <div class="row">
                        <div class="col-md-4 my-2">
                          <label class="form-label">{{ item.name }}</label>
                          <button type="button" class="btn btn-sm btn-light-danger ms-2" @click="removeCategoryQuickAddRow(index)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                        <div class="col-md-4 my-2">
                          <label class="required form-label">{{ $t('product.sell_price_ht') }}</label>
                          <input required type="number" min="0" v-model="item.sellPrice" class="form-control h-50px" />
                        </div>
                        <div class="col-md-4 my-2">
                          <label class="form-label">{{ $t('product.taxes') }}</label>
                          <select class="form-select kt_select2 h-50px" data-control="select2" name="cat_taxes[]"
                                  :data-product-key="index"
                                  data-dropdown-parent="#quickAddByCategoryModal" multiple>
                            <option v-for="taxe in getTaxes" :key="taxe.id" :value="taxe.id">{{ taxe.title }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isQuickAddLoading || categoryQuickAddProducts.length === 0">
                {{ $t('button.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import {mapActions,mapGetters} from "vuex";
import {BASE_URL} from "@/services/api";
import UpdateShopProduct from "@/components/shop/UpdateShopProduct";

export default {
  name: "Products",
  components: {UpdateShopProduct},
  data(){
    return{
      formProductEditData: {
        id: null,
        name: '',
        price : 0,
        stock_security : 0,
        stock_alert : 0,
        row: null,
        product_shop_taxes: []
      },
      formProductDeleteData: {
        id: null,
        row: null
      },
      isLoading: false,
      taxes: {},
      shop: {},
      currency: {},
      quickAddAction: '',
      quickAddProducts: [{ id: null, sellPrice: 0, taxes: [] }],
      selectedCategories: [],
      categoryQuickAddProducts: [],
      isQuickAddLoading: false
    }

  },
  computed: {
    ...mapGetters('taxes', [
      'getTaxes'
    ]),
    ...mapGetters('countries', [
      'getCountries'
    ]),
    ...mapGetters('products', [
      'getProductSaleElements'
    ]),
    ...mapGetters('categories', [
      'getCategories'
    ]),
  },
  watch:{
    '$i18n.locale' : function(value){
      if(value && this.table){
        this.$nextTick(() =>   this.fetchDatas())
   }
},
    '$route.params.id': function(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // les colonnes du tableau restent celles de l'ancienne boutique (ex. la
      // colonne "Stock de sécurité" se désynchronise de l'en-tête, qui lui se
      // met à jour car réactif) alors que la datatable garde l'ancienne liste.
      if (newId && newId !== oldId) {
        this.initForShop()
      }
    },
  },
  async mounted() {
      await this.initForShop()
      $(document).on("click", "#kt_datatable_shop_products .delete_btn", (e) => {
        this.formProductDeleteData.id = e.target.getAttribute('data-id')
        this.formProductDeleteData.row = e.target.getAttribute('data-row')
        this.removeProductRow()
      });

    $(document).on("click", "#kt_datatable_shop_products .btn_change_online", (e) => {
      const id = e.target.getAttribute('data-id')
      this.updateProductStatusData(id)
    });

      $(document).on("click", "#kt_datatable_shop_products .edit_btn", (e) => {
        this.formProductEditData.id = e.target.getAttribute('data-id')
        this.formProductEditData.name = e.target.getAttribute('data-name')
        this.formProductEditData.price = e.target.getAttribute('data-price')
        //this.formProductEditData.stock_variable = e.target.getAttribute('data-stock-variable')
        this.formProductEditData.stock_security = e.target.getAttribute('data-stock-security')
        this.formProductEditData.stock_alert = e.target.getAttribute('data-stock-alert')
        this.formProductEditData.row = e.target.getAttribute('data-row')
        this.formProductEditData.product_shop_taxes = e.target.getAttribute('data-taxes') ? e.target.getAttribute('data-taxes').split(",") : []

        $('#updateShopProductModal').modal('toggle')
      });

      this.initSelect2()

      $(".kt_select2").select2()

      $('#kt_select3').select2({
        placeholder: "Selectionnez le type"
      })

      $("#updateShopProductModal").on("shown.bs.modal", function () {
        $('.kt_select2').select2().select2();
      }),

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'countries[]':
            let countries = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k<kLen; k++) {
              if(e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined){
                countries.push(e.target.selectedOptions[k].value);
              }
            }
            this.formCreateTaxeData.countries = countries
            break;
          case 'tax_type':
            this.formCreateTaxeData.type = e.target.value
            break;
          case 'quick_add_action':
            this.handleQuickAddAction(e.target.value)
            this.quickAddAction = ''
            break;
          default:
            break;
        }
      });
  },
  methods: {
    async initForShop() {
      // S'assure que les modules actifs (pos.stock, ...) sont chargés avant de
      // construire le tableau : le layout parent les charge aussi, mais rien
      // ne garantit qu'il ait fini avant que ce composant ne monte.
      await this.loadShopModules(this.$route.params.id)
      this.fetchDatas()
      await this.loadTaxes()
      let response = await this.showShop(this.$route.params.id)
      this.shop = response.data.shop
      if (!this.$hasShopModule('pos.stock')) {
        this.loadAllProductSale()
        this.loadCategories()
        let currencyResponse = await this.getCurrency()
        this.currency = currencyResponse.data
      }
    },
    ...mapActions('shop', [
      'showShop',
      'removeProductFromShop',
      'updateShopProductStatus',
      'addProductsInShop',
      'getCurrency'
    ]),

    ...mapActions('taxes',[
        'createTaxe', 'loadTaxes'
    ]),

    ...mapActions('products', [
        'loadAllProductSale'
    ]),

    ...mapActions('categories', [
        'loadCategories'
    ]),

    ...mapActions('tenantModule', [
        'loadShopModules'
    ]),

    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_shop_products").DataTable({
        destroy: true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
          url: BASE_URL + '/get/shop/' + this.$route.params.id + '/products/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {

          }
        },
        columns: (() => {
          const cols = [{data: "name"}, {data: "price"}, {data: "priceTTC"}]
          if (this.$hasShopModule('pos.stock')) {
            cols.push({data: "stock_variable"})
          }
          cols.push({data: "online"})
          if (this.$hasShopModule('pos.stock')) {
            cols.push({data: "stock_security"}, {data: "stock_alert"})
          }
          cols.push({data: "Actions", responsivePriority: -1})
          return cols
        })(),

        columnDefs: (() => {
          let idx = 0
          const nameIdx = idx++
          const priceIdx = idx++
          const priceTTCIdx = idx++
          const hasStock = this.$hasShopModule('pos.stock')
          const stockVariableIdx = hasStock ? idx++ : null
          const onlineIdx = idx++
          const stockSecurityIdx = hasStock ? idx++ : null
          const stockAlertIdx = hasStock ? idx++ : null
          const actionsIdx = idx++

          const defs = [
            {
              targets: nameIdx,
              order: "desc",
              className: "dt-center clickable",
              render: (t, a, e, l) => {
                // sur mobile, cette cellule résume l'article (prix, stock) : les colonnes correspondantes sont masquées en CSS
                const stock = hasStock
                  ? '<span class="badge-sm badge-light-' + (Number(e.stock_variable) > 0 ? 'success' : 'danger') + '">' + i18n.global.t('product.stock') + ' : ' + e.stock_variable + '</span>'
                  : ''
                const summary = '<div class="shop-prod-mobile">'
                  + '<div class="fw-bolder text-gray-800">' + this.$formatLocalAmount(e.priceTTC) + ' ' + e.currency + ' <span class="text-muted fw-normal fs-8">TTC</span></div>'
                  + '<div class="text-muted fs-7">HT : ' + this.$formatLocalAmount(e.price) + ' ' + e.currency + '</div>'
                  + stock
                  + '</div>'
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + ' shop-prod-name">' + t + "</span>" + summary;
              },
            },
            {
              targets: priceIdx,
              order: "desc",
              className: "dt-center clickable shop-col-extra",
              render: (t, a, e, l) => {
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ e.currency +"</span></span>";
              },
            },
            {
              targets: priceTTCIdx,
              order: "desc",
              className: "dt-center clickable shop-col-extra",
              render: (t, a, e, l) => {
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ e.currency +"</span></span>";
              },
            },
          ]

          if (hasStock) {
            defs.push(
              {
                targets: stockVariableIdx,
                order: "desc",
                className: "dt-center clickable shop-col-extra",
                render: function (t, a, e, l) {
                  return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
                },
              },
              {
                targets: stockSecurityIdx,
                order: "desc",
                className: "dt-center clickable shop-col-extra",
                render: function (t, a, e, l) {
                  return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
                },
              },
              {
                targets: stockAlertIdx,
                order: "desc",
                className: "dt-center clickable shop-col-extra",
                render: function (t, a, e, l) {
                  return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
                },
              },
            )
          }

          defs.push(
            {
              targets: onlineIdx,
              orderable:false,
              searchable:false,
              render:  (t, a, e, l) => {
                if(this.$can('product_boutique_view')  ){
                  if(e.online){
                    return '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label><input type="checkbox" checked id="'+ e.id +'"  class="form-check-input online h-20px w-30px" data-id="'+ e.id +'" /><span></span></label></span>';
                  }else{
                    return '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label> <input type="checkbox" data-id="'+ e.id +'"  id="'+ e.id +'" class="form-check-input h-20px w-30px"/><span></span></label></span>';
                  }
                }
              },
            },
            {
              targets: actionsIdx,
              "className": "dt-center",
              title: "Actions",
              orderable: !1,
              render: (t, a, e, l) => {
                let render = ""
                if(!this.shop.archive){
                  if(this.$can('product_boutique_update')  ){
                    render+='<button type="button" data-row="'+ l.row +'" data-id="'+ e.id +'" data-price="'+ e.price +'" data-name="'+ e.name +'"  data-stock-variable="'+ e.stock_variable +'" data-stock-security="'+ e.stock_security +'" data-taxes="'+ e.taxe_id +'" data-stock-alert="'+ e.stock_alert +'" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto edit_btn" title="'+ i18n.global.t('button.edit') +'">' +
                        '<i  data-row="'+ l.row +'" data-id="'+ e.id +'" data-price="'+ e.price +'" data-name="'+ e.name +'"  data-stock-variable="'+ e.stock_variable +'" data-stock-security="'+ e.stock_security +'" data-taxes="'+ e.taxe_id +'" data-stock-alert="'+ e.stock_alert +'"  class="fa fa-pencil-alt"></i>' +
                        '</button> '
                  }
                }

                return render

              },
            },
          )

          return defs
        })(),
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    initSelect2()
    {
      $(".kt_select2").select2()

      $(".kt_select2").select2().select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'categories':
            this.formCreateData.categories[e.target.getAttribute('data-key')].category_id = e.target.value
            break;
          case 'productSaleElements':
            this.formCreateProductData.productSaleElements[e.target.getAttribute('data-key')].productSaleElement_id = e.target.value
            break;
            case 'taxes[]':
              let key = e.target.getAttribute('data-key')
              let result = [];
              for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
                if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                  result.push(e.target.selectedOptions[i].value);
                }
              }
              this.formCreateProductData.productSaleElements[key].taxes = result
              //this.formCreateData.categories[key].categorieTaxes = result
              break;
          case 'categorieTaxes[]':
            let catkey = e.target.getAttribute('data-key')
            let catresult = [];
            for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
              if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                catresult.push(e.target.selectedOptions[i].value);
              }
            }
            this.formCreateData.categories[catkey].categorieTaxes = catresult
            break;
          default:
            break;
        }
      });
    },

    async removeProductRow() {
      let response = {}
      Swal.fire({
        title: i18n.global.t("shop.shop_product_removed"),
        text: i18n.global.t("shop.action_irreversible"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.value) {
          try {
            let data = {
              product_sale_element_id:  this.formProductDeleteData.id,
              id: this.$route.params.id
            }
            response = await this.removeProductFromShop(data)
            window.toastr['success'](i18n.global.t("notification.message_shop_product_removed"))

            let res1 = await this.showShop(this.$route.params.id)
            this.categories = res1.data.categories

            this.table.ajax.reload()

          } catch(err){
            this.isLoading = false;
          }
        }
      });
    },

    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },

    loadShopProduct(){
      this.table.ajax.reload()
    },

    async  updateProductStatusData(id) {
      let response = {}
      let data = {
        shop : this.$route.params.id,
        product : id
      }
      try {
        response = await this.updateShopProductStatus(data)
        window.toastr['success'](i18n.global.t("notification.shop_product_online"))
      }catch (e) {
        window.toastr['success'](i18n.global.t('notification.promotion.update_status_error'))
      }
    },

    handleQuickAddAction(action) {
      switch (action) {
        case 'add_item':
          this.openQuickAddModal()
          break
        case 'add_by_category':
          this.openQuickAddByCategoryModal()
          break
      }
    },

    openQuickAddModal() {
      this.quickAddProducts = [{ id: null, sellPrice: 0, taxes: [] }]
      $('#quickAddShopProductModal').modal('toggle')
      this.$nextTick(() => {
        $('#quickAddShopProductModal .kt_select2').select2()
        $('#quickAddShopProductModal').off('change', '.kt_select2').on('change', '.kt_select2', (e) => {
          const index = e.target.getAttribute('data-product-key')
          if (index === null) return
          switch (e.target.name) {
            case 'product':
              this.quickAddProducts[index].id = e.target.value
              const selectedProduct = this.getProductSaleElements.find(p => p.id === e.target.value)
              if (selectedProduct) {
                this.quickAddProducts[index].sellPrice = selectedProduct.price || 0
              }
              break
            case 'taxes[]':
              const result = []
              for (let i = 0; i < e.target.selectedOptions.length; i++) {
                const val = e.target.selectedOptions[i].value
                if (val !== '' && val !== undefined) result.push(val)
              }
              this.quickAddProducts[index].taxes = result
              break
          }
        })
      })
    },

    addQuickAddRow() {
      this.quickAddProducts.push({ id: null, sellPrice: 0, taxes: [] })
      this.$nextTick(() => $('#quickAddShopProductModal .kt_select2').select2())
    },

    removeQuickAddRow(index) {
      if (this.quickAddProducts.length > 1) {
        this.quickAddProducts.splice(index, 1)
      }
    },

    filterQuickAddProducts(index) {
      const selectedIds = this.quickAddProducts
        .filter((item, i) => i !== index && item.id)
        .map(item => item.id)
      return this.getProductSaleElements.filter(product => !selectedIds.includes(product.id))
    },

    openQuickAddByCategoryModal() {
      this.selectedCategories = []
      this.categoryQuickAddProducts = []
      $('#quickAddByCategoryModal').modal('toggle')
      this.$nextTick(() => {
        $('#quickAddByCategoryModal .kt_select2').select2()
        $('#quick_add_category_select').val(null).trigger('change')
        $('#quick_add_category_select').off('change').on('change', (e) => {
          const selected = []
          for (let i = 0; i < e.target.selectedOptions.length; i++) {
            const val = e.target.selectedOptions[i].value
            if (val !== '' && val !== undefined) selected.push(val)
          }
          this.selectedCategories = selected
          this.loadCategoryQuickAddProducts()
        })
        $('#quickAddByCategoryModal').off('change', 'select[name="cat_taxes[]"]').on('change', 'select[name="cat_taxes[]"]', (e) => {
          const index = e.target.getAttribute('data-product-key')
          if (index === null) return
          const result = []
          for (let i = 0; i < e.target.selectedOptions.length; i++) {
            const val = e.target.selectedOptions[i].value
            if (val !== '' && val !== undefined) result.push(val)
          }
          this.categoryQuickAddProducts[index].taxes = result
        })
      })
    },

    loadCategoryQuickAddProducts() {
      this.categoryQuickAddProducts = []
      this.selectedCategories.forEach(catId => {
        const filtered = this.getProductSaleElements.filter(p => p.product_category_id === catId)
        filtered.forEach(p => {
          this.categoryQuickAddProducts.push({
            id: p.id,
            name: p.declination_title,
            sellPrice: p.price || 0,
            taxes: [],
          })
        })
      })
      this.$nextTick(() => $('#quickAddByCategoryModal .kt_select2').select2())
    },

    removeCategoryQuickAddRow(index) {
      this.categoryQuickAddProducts.splice(index, 1)
    },

    async submitQuickAddByCategory() {
      this.isQuickAddLoading = true
      try {
        const payload = {
          id: this.$route.params.id,
          productSaleElements: this.categoryQuickAddProducts.map(item => ({
            productSaleElement_id: item.id,
            price: item.sellPrice,
          })),
          taxes: [...new Set(this.categoryQuickAddProducts.flatMap(item => item.taxes || []))],
        }
        await this.addProductsInShop(payload)
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'))
        $('#quickAddByCategoryModal').modal('toggle')
        this.table.ajax.reload()
      } catch (err) {
        window.toastr['error'](err.message || i18n.global.t('notification.promotion.update_status_error'))
      }
      this.isQuickAddLoading = false
    },

    formatDateToday() {
      let date = new Date().getDate()
      let month = new Date().getMonth() + 1
      let year = new Date().getFullYear()
      return `${(date < 10) ? '0' + date : date}/${(month < 10) ? '0' + month : month}/${year}`
    },

    async submitQuickAdd() {
      this.isQuickAddLoading = true
      try {
        const payload = {
          id: this.$route.params.id,
          productSaleElements: this.quickAddProducts.map(item => ({
            productSaleElement_id: item.id,
            price: item.sellPrice,
          })),
          taxes: [...new Set(this.quickAddProducts.flatMap(item => item.taxes || []))],
        }
        await this.addProductsInShop(payload)
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'))
        $('#quickAddShopProductModal').modal('toggle')
        this.table.ajax.reload()
      } catch (err) {
        window.toastr['error'](err.message || i18n.global.t('notification.promotion.update_status_error'))
      }
      this.isQuickAddLoading = false
    },
  }
}
</script>

<style scoped>
.quick-add-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #7e8299;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.quick-add-close-btn:hover,
.quick-add-close-btn:focus,
.quick-add-close-btn:active {
  color: #7e8299;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
</style>

<style>
/* Articles de la boutique : sur mobile, la cellule nom résume l'article et les colonnes détaillées sont masquées */
.shop-products-table .shop-prod-mobile {
  display: none;
}

@media (max-width: 575.98px) {
  .shop-products-table thead,
  .shop-products-table .shop-col-extra {
    display: none !important;
  }

  .shop-products-table td:first-child {
    text-align: left;
  }

  .shop-products-table .shop-prod-name {
    font-weight: 600;
    color: #181c32;
  }

  .shop-products-table .shop-prod-mobile {
    display: block;
    margin-top: 2px;
  }
}
</style>
